import { MINUTES_IN_HOUR } from '../constants/time';
import { padTwo } from '../helpers/padTwo';
// formatDurationTime(90) -> "01 : 30"
// formatDurationTime(5)  -> "00 : 05"
export const formatDurationTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / MINUTES_IN_HOUR);
    const minutes = totalMinutes % MINUTES_IN_HOUR;
    return `${padTwo(hours)} : ${padTwo(minutes)}`;
};
